import { jsx as _jsx } from "react/jsx-runtime";
import s from './Toggle.module.css';
export function Toggle({ on, onChange, disabled, 'aria-label': ariaLabel, }) {
    return (_jsx("button", { type: "button", role: "switch", "aria-checked": on, "aria-label": ariaLabel, "data-on": on ? 'true' : 'false', disabled: disabled, className: s.root, onClick: () => onChange(!on) }));
}
